import React, { memo } from "react";

import { Box } from "@mui/material";

import {
    CommonLandingPageSteps,
    EditLandingPageSteps,
} from "../../AddEditLandingPage.types";
import ConnectionsStep from "../../Steps/ConnectionsStep";
import FunnelStep from "../../Steps/FunnelStep";
import GeneralStep from "../../Steps/GeneralStep";
import OverviewStep from "../../Steps/OverviewStep";
import PageContentStep from "../../Steps/PageContentStep";
import PaywallIntegrationStep from "../../Steps/PaywallIntegrationStep";
import PreviewAndLaunchStep from "../../Steps/PreviewAndLaunchStep";
import TemplateStep from "../../Steps/TemplateStep";

export default memo(function StepManager({
    landingPageDetails,
    step,
    setStep,
    setCompletedSteps,
    setIsStepDirty,
    pageURL,
    form,
    isDraft,
    onSave,
    completedSteps,
    templates,
    customSources,
    gamificationTemplates,
}) {
    const selectedTemplatedID =
        form?.[CommonLandingPageSteps.TEMPLATE]?.template_id;
    const mmpField = form?.[CommonLandingPageSteps.CONNECTIONS]?.mmp;
    const appleIdField = form?.[CommonLandingPageSteps.CONNECTIONS]?.mmp;
    const selectedAppTypes =
        form?.[CommonLandingPageSteps.CONNECTIONS]?.app_type;
    const gamificationType =
        form?.[CommonLandingPageSteps.CONNECTIONS]?.gamification_type;
    const selectedCustomSourceId =
        form?.[CommonLandingPageSteps.CONNECTIONS]?.lead_source_api_id;
    const commonProps = {
        landingPageDetails,
        onSave: (payload) => onSave(payload),
        selectedTemplatedID,
        form: form[step],
        mmpField,
        appleIdField,
        selectedAppTypes,
        gamificationType,
        selectedCustomSourceId,
        pageURL,
        setStep,
        isStepCompleted: completedSteps?.includes(step),
        setCompletedSteps,
        setIsStepDirty,
        isDraft,
        templates,
        customSources,
        gamificationTemplates,
    };

    const renderStep = () => {
        switch (step) {
            case EditLandingPageSteps.OVERVIEW:
                return <OverviewStep {...commonProps} />;
            case CommonLandingPageSteps.GENERAL:
                return <GeneralStep {...commonProps} />;
            case CommonLandingPageSteps.TEMPLATE:
                return <TemplateStep {...commonProps} />;
            case CommonLandingPageSteps.PAYWALL_INTEGRATION:
                return <PaywallIntegrationStep {...commonProps} />;
            case CommonLandingPageSteps.CONNECTIONS:
                return <ConnectionsStep {...commonProps} />;
            case CommonLandingPageSteps.PAGE_CONTENT:
                return <PageContentStep {...commonProps} />;
            case "FUNNEL":
                return <FunnelStep {...commonProps} />;
            case CommonLandingPageSteps.PREVIEW_AND_LAUNCH:
                return <PreviewAndLaunchStep {...commonProps} />;

            default:
                return null;
        }
    };

    return (
        <Box
            sx={{
                position: "relative",
                width: "100%",
                flex: 1,
                minWidth: 0,
                minHeight: 0,
                height: { xs: "auto", md: "100%" },
            }}
        >
            {renderStep()}
        </Box>
    );
});
